export interface TrackingSearchContext {
  pageType: '' | 'search';
  query: string;
}

export function resolveSearchContext(href: string): TrackingSearchContext {
  try {
    const url = new URL(href);
    const proxiedPath = url.searchParams.get('path');
    const effectivePath = proxiedPath
      ? new URL(proxiedPath, url.origin).pathname
      : url.pathname;
    const isSearch = effectivePath === '/search' || effectivePath.startsWith('/search/');
    if (!isSearch) {
      return { pageType: '', query: '' };
    }
    return {
      pageType: 'search',
      query: (url.searchParams.get('key') ?? '').trim(),
    };
  } catch {
    return { pageType: '', query: '' };
  }
}
